import { useCredentialingTranslation } from './useCredentialingTranslation';
export function useAccountsLocationInformationFilters() {
    const { t } = useCredentialingTranslation();
    const locationInformationFilters = (builder, regionEnabled) => {
        builder.allFiltersPanel({
            label: t('filters.locationInformation.groupTitle'),
            key: '!location',
            children: [
                builder.allFiltersWidget({
                    label: t('common.city'),
                    type: 'form.text',
                    key: 'city',
                }),
                builder.allFiltersWidget({
                    label: t('common.zipCode'),
                    type: 'form.text',
                    key: 'postalCode',
                }),
                builder.allFiltersWidget({
                    label: t('common.state'),
                    type: 'form.select',
                    key: 'state',
                    valueProvider: {
                        type: 'classifier.state',
                    },
                }),
                builder.allFiltersWidget({
                    label: t('common.county'),
                    type: 'form.multiSelect',
                    key: 'county',
                    valueProvider: {
                        type: 'classifier.county',
                        paramsFromFormData: 'state',
                    },
                }),
                builder.allFiltersWidget({
                    label: t('common.tribe'),
                    type: 'form.multiSelect',
                    key: 'tribeId',
                    valueProvider: {
                        type: 'classifier.tribe',
                    },
                }),
                ...(regionEnabled
                    ? [
                        builder.allFiltersWidget({
                            label: t('filters.region'),
                            type: 'form.select',
                            key: 'region',
                            valueProvider: {
                                type: 'classifier.region',
                            },
                        }),
                    ]
                    : []),
            ],
        });
    };
    return { locationFilters: locationInformationFilters };
}
export function useUserDirectoryLocationInformationFilters() {
    const { t } = useCredentialingTranslation();
    const locationInformationFilters = (builder, regionEnabled) => {
        const locationPanel = builder.findAllFiltersWidget('!locationInformation');
        locationPanel === null || locationPanel === void 0 ? void 0 : locationPanel.children.push(builder.allFiltersWidget({
            label: t('common.tribe'),
            type: 'form.multiSelect',
            key: 'tribeId',
            valueProvider: {
                type: 'classifier.tribe',
            },
        }), ...(regionEnabled
            ? [
                builder.allFiltersWidget({
                    label: t('filters.region'),
                    type: 'form.select',
                    key: 'region',
                    valueProvider: {
                        type: 'classifier.region',
                    },
                }),
            ]
            : []));
    };
    return { locationFilters: locationInformationFilters };
}
